// extracted by mini-css-extract-plugin
export var dividerLine = "_4e-0";
export var errorBackground = "_4e-1";